const DOWNLOAD = {
    onReady() {
        this.page = document.querySelector('.download');
        if (this.page === null) return;
        DOWNLOAD.buildPages();
    },
    buildPages() {
        let mmToPx        = parseFloat(DOWNLOAD.page.clientHeight / 297); // One Millimeter in Pixel
        let padding       = 45; // mm
        let contentHeight = parseFloat((297 - padding) * mmToPx);
        var totalHeight   = 0;
        var currentHeight = 0;
        let sections      = document.querySelectorAll('.download__section');
        sections.forEach(section => {
            totalHeight += section.clientHeight;
        });
        let pageCount = Math.ceil(totalHeight / contentHeight);
        var jj = 0;
        for (var ii = 1; ii <= pageCount; ii++) {
            let template = document.getElementById('template-page').content.cloneNode(true);
            for (var kk = jj; kk < sections.length; kk++) {
                currentHeight += sections[jj].clientHeight;
                if (currentHeight < contentHeight) {
                    template.querySelector('.download').insertAdjacentHTML('beforeend', `<div class='${sections[jj].className}'>${sections[jj].innerHTML}</div>`);
                    template.querySelector('.download__footer--right').innerHTML = `${ii}/${pageCount}`;
                    jj++;
                } else if (jj <= sections.length && ii + 1 > pageCount) { // Fallback for the very last section which doesn't match the above criteria
                    template.querySelector('.download').insertAdjacentHTML('beforeend', `<div class='${sections[jj].className}'>${sections[jj].innerHTML}</div>`);
                }
            }
            currentHeight = 0;
            this.page.parentNode.insertBefore(template, this.page);
        }
        this.page.remove();
    }
}